module.exports = __webpack_public_path__ + "img/diners.535563c.png";